import { z } from 'zod';
import { DEVISES } from '../model/commun.js';
export const CATEGORIES_COUT_EXPOSITION = [
    'stand',
    'transport',
    'sejour',
    'commission_foire',
    'communication',
    'autre',
];
export const coutExpositionSchema = z.strictObject({
    categorie: z.enum(CATEGORIES_COUT_EXPOSITION, { error: 'Catégorie de coût inconnue.' }),
    libelle: z
        .string()
        .trim()
        .min(1, 'Le libellé est requis.')
        .max(200, 'Ce texte ne peut pas dépasser 200 caractères.'),
    montantCentimes: z
        .number()
        .int('Le montant doit être entier.')
        .positive('Le montant doit être positif.')
        .max(Number.MAX_SAFE_INTEGER, 'Ce montant est trop élevé.'),
    devise: z.enum(DEVISES, { error: 'Devise inconnue.' }),
    date: z.iso.date({ error: 'Une date civile est requise.' }),
    fournisseur: z
        .string()
        .trim()
        .max(200, 'Ce texte ne peut pas dépasser 200 caractères.')
        .default(''),
    note: z.string().max(2000, 'La note ne peut pas dépasser 2 000 caractères.').default(''),
});
export const reglagesPilotageSchema = z.strictObject({
    moisDormance: z
        .number()
        .int('Le seuil doit être entier.')
        .min(3, 'Le seuil doit être au moins de 3 mois.')
        .max(36, 'Le seuil ne peut pas dépasser 36 mois.'),
});
//# sourceMappingURL=contrats.js.map